import PropTypes from "prop-types"
import classNames from "classnames"
import { map, get, isFunction } from "lodash"
import { Grid } from "@mui/material"
import { StarRounded } from "@mui/icons-material"
import Ellipsable from "components/ellipsable"

export default function FactorRow({ factor, categoryColor, values, valueClassNames, fixed, getColumnColorStyle, maxLabelWidth }) {
  const { id, label, favorite } = factor

  return (
    <Grid container key={id} className={classNames("factor-row", { favorite, fixed })}>
      <Grid container className="factor-label" sx={{ width: "100%" }}>
        <span className="label">
          {favorite && <StarRounded className="star-icon" style={{ color: categoryColor }} />}
          <Ellipsable width={maxLabelWidth}>{label}</Ellipsable>
        </span>
      </Grid>
      <Grid container className="values" sx={{ width: "100%" }}>
        {map(values, (value, index) => {
          const extraAttributes = {
            ...(isFunction(getColumnColorStyle) && {
              "data-color": get(getColumnColorStyle(index), "backgroundColor"),
              style: getColumnColorStyle(index),
            }),
          }
          return <div key={`row-factor-${index}`} className={classNames("value", get(valueClassNames, index, ""))} {...extraAttributes}>
            <span>{value}</span>
          </div>
        },
        )}
      </Grid>
    </Grid>
  )
}

FactorRow.propTypes = {
  factor: PropTypes.object.isRequired,
  categoryColor: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  valueClassNames: PropTypes.array,
  fixed: PropTypes.bool,
  getColumnColorStyle: PropTypes.func,
  maxLabelWidth: PropTypes.number,
}
